document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.before-after-comparison .slider-wrapper');
    
    containers.forEach(container => {
        const slider = container.querySelector('.slider');
        
        if (slider) {
            slider.addEventListener('input', (e) => {
                container.style.setProperty('--position', `${e.target.value}%`);
            });
        }
    });
});